export default {
  siteName: "PixelHaha",
  creation: "AI画像",
  faceSwap: "フェイススワップ",
  product: "製品",
  magicBrush: "マジックブラシ",
  discover: "発見する",
  profile: "プロフィール",
  pricing: "価格",
  freeCredits: "無料クレジット",
  credits: "積分",
  getMoreCredits: "クレジットを追加",
  left: "左",
  upgradeToPremium: "プレミアムにアップグレード",
  go: "行く！",
  accountInformation: "口座情報",
  signOut: "サインアウト",
  getMore: "多くを得る",
  contactSupport: "サポート問い合わせ先",
  history: "履歴",
  login: "ログイン",
  signup: "サインアップ",
  aiFuture: "AI機能",
  photoFaceSwap: "写真の顔の交換",
  photoMutipleFaceSwap: "複数の写真の顔の交換",
  videoFaceSwap: "フェイススワップビデオメーカー",
  videoMutipleFaceSwap: "複数のビデオの顔の交換",
  multipleFaceSwap: "複数フェイススワップ",
  aIImageGenerator: "AI画像生成",
  support: "サポート",
  language: "言語",
  // userPolicy: "利用規約",
  // privacyPolicy: "プライバシーポリシー",
  // refundPolicy: "返金ポリシー",
  userPolicy: "利用規約",
  privacyPolicy: "プライバシーポリシー",
  refundPolicy: "返金ポリシー",
  FLARKLaw: '18 U.S.C 2257 免除',
  policies: "ポリシー",
  intellectual: "知的財産権",
  about: "私たちについて",
  blog: "ブログ",
  helpAndFAQS: "ヘルプ & FAQ",
  sitemap: "サイトマップ",
  bussiness: "仕事",
  affiliateProgram: "アフィリエイトプログラム",
  api: "API",
  contactUs: "お問い合わせ",
  aiFaceFunTitle: "AI ビデオ フェイス スワップ オンライン",
  aiFaceFunSubTitle:
    "PixelHaha ビデオ フェイス スワップで顔を瞬時に交換します。 写真やビデオ内の顔を選択した人物に変更します。 当社の AI を活用した製品で面白いミームを作成します。",
  startFaceButtonTitle: "フェイススワップを開始",
  details: "詳細  >",
  chooseFace: "顔を選ぶ",
  faceSwaps: "顔の交換",
  tryAgain: "もう一度やり直してください",
  faceswapUploadArea: {
    tab1Desc1: "顔を入れ替える元の写真をアップロードします。",
    tab1Desc2: "写真をドラッグアンドドロップするか、写真を選択してください",
    tab2Desc1: "顔を入れ替える元の写真をアップロードします。",
    tab2Desc2: "画像をドラッグアンドドロップするか、画像を選択してください",
    tab3Desc1: "顔を入れ替える元のビデオをアップロードします。",
    tab3Desc2: "ビデオをドラッグアンドドロップするか、ビデオを選択してください",
    tab4Desc1: "顔を入れ替える元のビデオをアップロードします。",
    tab4Desc2: "ビデオをドラッグアンドドロップするか、ビデオを選択してください",
    tab1title: "オンラインで写真や画像の顔を交換する3つのステップ",
    tab1step1: "1. オリジナルの顔写真をアップロードします。",
    tab1step2:
      "2. 元の写真の顔を置き換える人物の顔写真をアップロードします。提供されている写真デモから選択することもできます。",
    tab1step3:
      "3. 顔交換写真 を起動し、HD 結果をプレビューしてダウンロードします。",
    tab2title: "オンラインで写真内の複数の顔を交換する3つのステップ",
    tab2step1: "1. オリジナルの顔写真をアップロードします。",
    tab2step2:
      "2. 元の写真の顔を置き換える人物の顔写真をアップロードします。提供されている写真デモから選択することもできます。",
    tab2step3:
      "3. Face Swap Picture を起動し、HD 結果をプレビューしてダウンロードします。",
    tab3title: "オンラインで動画の顔を交換する3つのステップ",
    tab3step1: "1. オリジナルの顔動画をアップロードします。",
    tab3step2:
      "2. 元のビデオの顔を置き換える人物のターゲットの顔をアップロードします。提供されているデモから選択することもできます。",
    tab3step3:
      "3. ビデオ フェイス スワップを開始し、HD 結果をプレビューしてダウンロードします。",
    tab4title: "オンラインで動画の顔を交換する3つのステップ",
    tab4step1: "1. オリジナルの顔動画をアップロードします。",
    tab4step2:
      "2. 元のビデオの顔を置き換える人物のターゲットの顔をアップロードします。提供されているデモから選択することもできます。",
    tab4step3:
      "3. ビデオ フェイス スワップを開始し、HD 結果をプレビューしてダウンロードします。",
    chooseFiles: "ファイルを選択",
    photoLimit: "最大10MB",
    videoLimit: "最大500メートル、10分",
    uploading: "<xx1> をアップロードしています",
    faceAnalyzing: "顔分析",
    queuingAbout: "キューイング中...<xx1> について",
    analyzingAbout: "分析中...<xx1> について",
    somethingError: "何かが間違っています。後でもう一度試してください。",
  },

  review: {
    title: "彼らは私たちを愛しており、あなたもそうするでしょう",
    subtitle:
      "世界中の10,000人以上のパートナーのチームに参加してください。ウェブサイトから受け取る報酬は継続的で安定しています。",
    data1: {
      title: "PixelHahaが大好きです！",
      content:
        "PixelHahaが大好きです！写真に楽しいひねりを加えるための私のお気に入りのツールです。友達と顔を交換したり、さまざまな有名人のルックを試したりするたびに、結果は常に面白くて楽しいです。",
      name: "クリフ・クアン",
      dateText: "2024年3月2日",
    },
    data2: {
      title: "メイクアップ愛好家として",
      content:
        "メイクアップ愛好家として、PixelHahaを使って実際に試す前に新しいルックを試します。さまざまなキャラクターと顔を交換することで、さまざまなスタイルが自分にどのように見えるかを視覚化するのに役立ちます。メイクを試すのが好きな人には楽しくて実用的なツールです！",
      name: "アンリ・ブレヴォ",
      dateText: "2024年5月16日",
    },
    data3: {
      title: "ビデオ顔交換は簡単です",
      content:
        "ビデオ顔交換機能を使って、他の誰かと顔を交換するのは簡単です。映画スターの顔を自分の頭に置いたり、バスケットボール選手の顔と交換したりしたい場合、このツールは完璧に仕事をこなします。頑張ってください！",
      name: "エイダ・ウー",
      dateText: "2024年4月19日",
    },
    data4: {
      title: "この素晴らしいツールはインテリジェントに",
      content:
        "この素晴らしいツールは写真の顔をインテリジェントに検出し、選択した任意の顔とシームレスに交換します。まるで手元に自分の個人的なクリエイティブスタジオがあるかのようです！PixelHahaを使えば、どんな写真でも顔を簡単に交換できるので、手間なく想像力を解き放つことができます。",
      name: "マリオ・クーパー",
      dateText: "2024年1月24日",
    },
    data5: {
      title: "写真編集は常に難しいと感じていました",
      content:
        "写真編集は常に難しいと感じていましたが、PixelHahaはそれを簡単にしてくれます！さまざまなAI顔交換オプションを試して、面白い組み合わせを見て楽しむのが大好きです。これは私の写真にユーモアを加え、友達を笑わせるための素晴らしい方法です。",
      name: "クリス・ジン",
      dateText: "2023年12月12日",
    },
    data6: {
      title: "AI顔交換は面白いミームの作成に最適です",
      content:
        "AI顔交換は面白いミーム、ヘッドショット、顔交換ビデオの作成に最適です。PixelHahaはエンターテインメントだけでなく、魅力的なコンテンツ作成にも完璧です。ソーシャルメディアでより多くの注目を集めるのに役立ちます。",
      name: "コトラリコバ",
      dateText: "2024年3月24日",
    },
  },
  faq: {
    title: "よくある質問",
    details: "詳細 >",
    data1: {
      question: "PixelHahaとは何ですか？",
      answer:
        "PixelHahaは、複雑な写真編集ツールを必要とせずに、顔の交換、レタッチ、強化、カラー化、補正、カートゥーン化を自動的に行う先進的な技術を活用したビジュアルAIプラットフォームです。最新のAIアルゴリズムを活用して、PixelHahaは写真処理を簡素化し、個人ユーザーと大量の写真編集を必要とするビジネスユーザーの時間、エネルギー、コストを節約します。",
    },
    data2: {
      question: "AI顔交換ツールはどのように機能しますか？",
      answer:
        "AI顔交換は、高度な人工知能アルゴリズムに依存して、ソース画像を詳細に分析し、顔の特徴を認識し、自然な照明、角度、表情を維持しながら、別の顔にシームレスに置き換えます。これにより、AIが生成したリアルな顔交換が実現します。",
    },
    data3: {
      question: "ビデオ顔交換の使い方は？",
      answer:
        "まず、基になるクリアな正面画像を選択します。次に、自分の顔または有名人の顔のどちらを交換したいかを選択します。最後に、置換プロセスを開始すると、選択した顔が基の画像にシームレスに配置されます。",
    },
    data4: {
      question: "顔をどんな画像にでも置き換えられますか？",
      answer:
        "はい、もちろんです。PixelHahaを使用すると、選択した任意の画像と顔を無料で交換できます。例えば、男性の顔を女性のポートレートに置いたり、赤ちゃんの写真に老齢の顔を置いたりできます。可能性は無限で、制限なく誰にでもなれます。",
    },
    data5: {
      question: "最高の結果を得るにはどうすればよいですか？",
      answer:
        "顔交換で最適な結果を得るためのヒントを以下に示します：顔の特徴が明確に定義されたクリアな写真を選択し、ぼやけた画像は避けてください。写真に顔が1つだけあることを確認し、顔がカメラに直接向いており、手などの物で遮られていないことを確認してください。",
    },
    data6: {
      question: "無料でオンラインで顔を交換できますか？",
      answer:
        "もちろんです！PixelHahaを使用すると、無料でオンラインで顔を交換できます。ニーズに応じて無料プランとプレミアムプランの両方を提供しています。新しいユーザーとして登録すると、3つのクレジットが付与され、顔交換サービスと顔切り取りやアバター作成などの追加機能に完全にアクセスできます。",
    },
  },
  choose: {
    delText: "この顔を削除してもよろしいですか?",
    leftBtnText: "続く",
    rightBtnText: "キャンセル",
    overFaces:
      "アップロードできる顔の数が制限に達しました。続行するには他の顔を削除してください。",
    faceAn: "顔分析中...",
    facesuccess: "顔分析成功",
    facefailed: "顔分析に失敗しました",
    feedback: "ご意見ありがとうございます！",
    batchsupport:
      "バッチ処理がサポートされています。現在の結果に関係なく、新しい顔の交換を行うことができます。",
    batchsupportAIGirl:
      "バッチ処理に対応！現在の結果に関係なく、新しい AI 画像を作成できます。",
    submitting: "提出中",
    queuing: "キューイング",
    creating: "作成",
    downloading: "ダウンロード中",
    retryText: "何かが間違っています。後でもう一度試してください。",
    retry: "リトライ",
    emailTip:
      "有効なドメイン名サフィックス（.com、.net など）を入力してください。",
    noaccount: "まだアカウントがありませんか？",
    enterPassWord: "パスワードを入力する",
    passWordErr: "パスワードを8文字以上に設定する",
    loginPassWordErr: "パスワードは8文字以上でなければなりません",
    forgotpass: "パスワードをお忘れですか？",
    googlesign: "Google サインインでログインしますか?",
    resetpassword: "パスワードを再設定する",
    readyaccount: "すでにアカウントをお持ちですか？",
    confirm: "確認する",
    resetpasswordsuccess: "パスワードのリセットに成功しました!",
    senderror: "送信エラー!",
    sendsuccess: "送信成功！",
    signupfree: "無料でお申し込み頂けます",
    signupsuccess: "サインアップ成功！",
    sendcode: "送信コード",
    loginsuccess: "ログイン成功！",
    logingerror: "ログインエラー！",
    aboutS: "について {leftTime}s",
    keepPatient: "忍耐強く！",
    needMoretime: "もっと時間がかかります！",
    aimostDoneKeep: "もう少しで完成するところだった！忍耐強く！",
    usernamePlace: "user{'@'}example.com",
    emailCode: "認証コード",
  },
  feedbackDialog: {
    title: "PixelHaha を改善するには、皆様のフィードバックが必要です。",
    subTitle1: "改善したいですか?",
    option1: "アップロードされたファイルに関する不正確な顔分析",
    option2: "似ていない",
    option3: "顔の細部の問題（歪んでいる、目、口など）",
    option4: "スロータイム",
    option5: "結果の鮮明さ",
    txtOption1: "センシティブまたは不快な内容",
    txtOption2: "利用規約違反",
    txtOption3: "プロンプトの関連性",
    txtOption4: "顔が歪む",
    txtOption5: "画像コンテンツ",
    txtOption6: "画像の鮮明度",
    txtOption7: "スロータイム",
    subTitle2: "もっと言いたいことはありますか?",
    placeholder: "その他の提案...",
    submit: "提出する",
  },
  infoDialog: {
    advancedFeatures: "高度な機能",
    advancedFeaturesText:
      "ビデオでリアルな顔の交換機能を有効にするには、プランの料金をお支払いください。",
    choosePlan: "プランを選択",
    insufficientCredits: "クレジットが不足しています",
    insufficientCreditsText: "クレジット残高:",
    getMoreCredits: "クレジットをさらに獲得",
    videoTooBig: "ビデオが大きすぎます",
    videoTooLong: "ビデオが長すぎます",
    videoCannotExceed: "ビデオは",
    inFileSize: "ファイルサイズ",
    selectAnotherFile: "別のファイルを選択",
    photoTooBig: "写真が大きすぎます",
    photoCannotExceed: "写真は",
    tenMin: "10分",
    deleteFile: "このファイルを削除してもよろしいですか?",
    cancel: "キャンセル",
    confirm: "確認する",
  },
  allRightsReserved: "無断転載を禁じます。",
  aiGirlIntroductionDetails: "AI画像紹介詳細",
  aiGirlHowToUse: "AI画像使い方",
  discoverHot: "トレンド検索を見つける",
  aiGirlFAQDetails: "AI画像FAQ詳細",
  lookslikeUploadOpps: {
    title: "おっとっと！",
    subtitle:
      "おっと！無料クレジットの制限を超えました！\nすべての機能を無制限に使用するには、プランに加入してください。",
    unlockLimit: "制限を解除",
  },
  selectStyle: "スタイルを選択",
  purchasePopup: {
    title: "成功しました！",
    consumerSuccess: "<xx1> クレジットを獲得しました",
    subscribeSuccess: "無制限アクセス！当社のサービスをお楽しみください！",
    ok: "わかりました",
  },
  affiliatePopup: {
    title: "アフィリエイトプログラムチュートリアル",
    first: "初め",
    second: "2番",
    linkHint: "アフィリエイトプログラムリンク:",
    copy: "コピー",
    ok: "わかりました",
  },
  photoEnhanceDetails: "写真の詳細を強調する",
  videoEnhanceDetails: "ビデオ強化の詳細",
  imageEnhancer: "AIフォトエンハンサー",
  videoEnhancer: "AIビデオエンハンサー",
  socialShareTitle:
    "すごい！AI画像ジェネレータで作られたこの写真はすごいですね。",
  copySuccess: "コピー成功しました!",
  email: "メール",
  copy: "コピー",
};
